import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { CreativeAdvertisingCompanyListResponse } from '@modules/creatives-link/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  CREATIVES_LINK_PERMISSIONS,
  LOAD_CREATIVE_ADVERTISING_COMPANY_API_URL,
  LOAD_CREATIVE_ADVERTISING_COMPANY_QUERY_KEY,
} from '@modules/creatives-link/constants';

export default function useCreativeAdvertisingCompanyListQuery(
  merchant: Ref<number | undefined>,
  creativeResolutionRef: Ref<string | undefined>,
  creativeFormatRef: Ref<string | undefined>,
  creativeLanguageRef: Ref<string | undefined>,
): IContextQueryResult<CreativeAdvertisingCompanyListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<CreativeAdvertisingCompanyListResponse>({
    queryKey: [LOAD_CREATIVE_ADVERTISING_COMPANY_QUERY_KEY, merchant, creativeFormatRef, creativeResolutionRef, creativeLanguageRef],
    queryFn: ({ signal }) => fetchGet<CreativeAdvertisingCompanyListResponse>(
      LOAD_CREATIVE_ADVERTISING_COMPANY_API_URL,
      {
        signal,
        permission: CREATIVES_LINK_PERMISSIONS.SHOW,
        queryParams: {
          merchant: merchant.value,
          format: creativeFormatRef.value,
          creative_resolution_id: creativeResolutionRef.value ? creativeResolutionRef.value : '',
          language: creativeLanguageRef.value,
        },
      },
    ),
    gcTime: 0,
    enabled: computed(() => {
      if (creativeFormatRef.value === 'link') {
        return !!merchant.value && !!creativeFormatRef.value && !!creativeLanguageRef.value;
      }
      return !!merchant.value && !!creativeFormatRef.value && !!creativeResolutionRef.value && !!creativeLanguageRef.value;
    }),
  });
}
